.top-container {
  display: flex;
  gap: calc(var(--spacer) * 4);

  .chart-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    gz-donut-chart-widget {
      width: fit-content;
      height: fit-content;
      --top-padding: 0;
    }

    gz-text {
      line-height: 1.5;
      width: fit-content;
    }

    gz-progress-spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: fit-content;
      --bar-width: calc(var(--spacer) * 3);
      --bar-color: var(--grey-layout-203-dark-theme-disabled-text);
    }

    .remaining-days {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      color: var(--body-text-arrows-400);
      white-space: nowrap;
    }
  }

  .legend-container {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .learning-info-banner {
      height: auto;
      order: -1;
      margin-top: -40px;
    }

    .empty-legend-text {
      line-height: 1.5;
      width: fit-content;
      padding: 0 10%;
    }

    gz-loader {
      height: fit-content;

      &:not(:last-of-type) {
        margin-bottom: var(--spacer);
      }
    }

    .legend-item,
    .sub-legend-item {
      display: flex;
      align-items: center;
      width: 100%;
      height: calc(var(--spacer) * 4);
      min-height: fit-content;
      justify-content: space-between;

      &--color {
        margin-right: var(--spacer);
        height: 10px;
        width: 10px;
      }

      &--text {
        width: 50%;
        padding: calc(var(--spacer) / 2) 0;
      }

      &--count {
        align-items: center;
        display: flex;
      }

      &--percentage,
      &--value {
        --font-family: var(--font-family-secondary-mono);
      }

      &--percentage {
        margin-left: auto;
        width: fit-content;
        min-width: 50px;
        text-align: left;
      }

      &--slice-tooltip {
        width: 80%;
        margin-right: auto;
      }
    }

    .sub-legend-item {
      &--color{
        margin-left: var(--spacer);
      }
    }

    .legend-item {
      &:not(:first-of-type) {
        border-top: 1px solid var(--chart-101-pressed-dividers);
      }
    }
  }
}

.recommendations-container {
  margin-top: calc(var(--spacer) * 2);

  gz-widget-section-with-icons-and-percentage-item:last-of-type {
    --row-border-bottom: unset;
  }

  gz-loader {
    margin-bottom: var(--spacer);
  }
}

.viewAllSection {
  padding-top: calc(var(--spacer) * 3);
}

.icon-value {
  margin-right: calc(var(--spacer) / 2);
}
